export default __webpack_public_path__ + "static/media/microbiology-screening-solution.ab3b29cb.png";